import { SurveysApi } from 'entities/Surveys'
import { SurveysStatus, type IResponseGetSurvey } from 'entities/Surveys/api/types'
import { EnrollSearchStore } from 'widgets/EnrollSearch'

export type SurveySendSearchStore = EnrollSearchStore<IResponseGetSurvey>

export const createSurveySendSearchStore = (): SurveySendSearchStore =>
  new EnrollSearchStore<IResponseGetSurvey>({
    perPage: 10,
    getKey: (item) => item.id,
    fetchItems: async ({ term, offset, limit, cancelToken }) => {
      const page = Math.floor(offset / limit) + 1
      const {
        data: { data, meta },
      } = await SurveysApi.getSurveys(
        {
          page,
          limit,
          'filters[name]': term || undefined,
          'filters[status]': SurveysStatus.Active,
        },
        { cancelToken }
      )
      return { items: data, total: meta.total }
    },
  })
